export default {
  subscribe: null,
  unreadMessagesCount: 0,
  roomIds: [],
  rooms: [],
  roomMessages: []
};
